import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle, ChevronRight } from 'lucide-react';
type AlertCardProps = {
  title: string;
  description: string;
  onClick: () => void;
  viewDetailsLabel: string;
};
export function AlertCard({
  title,
  description,
  onClick,
  viewDetailsLabel
}: AlertCardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.5,
    delay: 0.2
  }} data-id="element-133">
      <button onClick={onClick} className="w-full p-5 border-2 border-red-500 bg-white rounded-xl cursor-pointer group hover:shadow-md transition-all text-left" data-id="element-134">
        <div className="flex items-start gap-4" data-id="element-135">
          <div className="flex-shrink-0" data-id="element-136">
            <AlertTriangle className="w-6 h-6 text-red-600" data-id="element-137" />
          </div>

          <div className="flex-1 min-w-0" data-id="element-138">
            <h4 className="font-semibold text-red-600" data-id="element-139">{title}</h4>
            <p className="text-sm text-gray-700 mt-1" data-id="element-140">{description}</p>
          </div>

          <div className="flex items-center gap-1 text-red-600 group-hover:text-red-700 transition-colors flex-shrink-0" data-id="element-141">
            <span className="text-sm font-medium hidden sm:inline" data-id="element-142">
              {viewDetailsLabel}
            </span>
            <ChevronRight className="w-5 h-5" data-id="element-143" />
          </div>
        </div>
      </button>
    </motion.div>;
}